import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=89965cae&lang=less"
import "./HomeView.vue?vue&type=style&index=1&id=89965cae&lang=less"

const __exports__ = script;

export default __exports__